import { Component, OnInit } from '@angular/core';
import { CodeService } from '../Services/code.service';

import { MyModalService } from '../Services/modal-service.service';
import { AuthService } from '../Services/auth.service';
import { Logininfo } from '../classes/Loginifo';

@Component({
  selector: 'app-items-setting',
  templateUrl: './items-setting.component.html',
  styleUrls: ['./items-setting.component.css']
})
export class ItemsSettingComponent implements OnInit {
  logininfo: Logininfo = this.auth.loginID;
  codeList;
  viewList;

  code_kbn_list;
  code_kbn;

  select_item;

  addkbn;
  formValue;
  formShow;


  constructor(
    private codeService: CodeService,
    private modal: MyModalService,
    public auth: AuthService,
  ) { }

  ngOnInit() {
    this.codeService.getCodeList().subscribe(result => {
      this.codeList = result;
      this.init();
    });
  }

  //初期化処理
  init() {
    //項目種類抽出
    let temp = this.codeList.filter(function (item, i, self) {
      return (self.findIndex(function (item2) {
        return (item.code_kbn === item2.code_kbn)
      }) === i);
    });

    let tempList = [];
    temp.forEach(item => {
      let i = {
        code_kbn: item.code_kbn,
        code_name: item.code_name
      }
      tempList.push(i);
    });

    //先頭の項目を選択
    this.code_kbn = tempList[Object.keys(tempList)[0]].code_kbn;

    this.code_kbn_list = tempList;
    this.viewer();
  }

  change() {
    this.selectClear();
    this.viewer();
  }

  //保存
  async update() {
    const res = await this.modal.confirm('保存', '変更を保存しますがよろしいでしょうか？');
    if (!res) {
      return;
    }

    this.codeService.updateCodeList(this.codeList).subscribe(res => {
      this.modal.message('保存完了', '保存完了しました');
      this.ngOnInit();
    });

  }

  //描画するリスト生成
  viewer() {
    this.codeList.sort(function (a, b) {
      if (a.code_kbn < b.code_kbn) return -1;
      if (a.code_kbn > b.code_kbn) return 1;
      if (a.disp_seq < b.disp_seq) return -1;
      if (a.disp_seq > b.disp_seq) return 1;
      return 0;
    })

    this.viewList = this.codeList.filter((item) => {
      return item.code_kbn === this.code_kbn;
    });
  }


  //削除
  async del(item) {
    const res = await this.modal.confirm('削除', '『' + item.question_info + '』を本当に削除してもよろしいですか？');
    if (!res) {
      return;
    }

    let kbn = item.code_kbn;

    if (item.code != null) {
      item.code_kbn = null;
      item.delete_flag = true;
    } else {
      let index = this.codeList.findIndex(i => i == item);
      this.codeList.splice(index, 1);
    }

    let sort = 1;
    this.codeList.forEach(item => {
      if (item.code_kbn == kbn) {
        item.disp_seq = sort;
        sort++;
      }
    });


    this.selectClear();
    this.viewer();
  }

  //クリックした行をselect
  select(item) {
    this.selectClear();
    this.select_item = item;
    item.select = true;
  }

  //selectを一旦全部消去
  selectClear() {
    this.select_item = null;
    this.viewList.forEach(item => {
      item.select = false;
    });
  }

  //項目の並び順変更
  prev() {
    if (!!this.viewList && this.select_item) {
      //選択中のindexと 1つ前のindex
      let index = this.codeList.findIndex(i => i.code_kbn == this.select_item.code_kbn && i.disp_seq === this.select_item.disp_seq);
      let index2 = this.codeList.findIndex(i => i.code_kbn == this.select_item.code_kbn && i.disp_seq === this.select_item.disp_seq - 1);

      if (index != 0) {
        if (index2 > -1) {
          let temp = this.codeList[index].question_sort;
          this.codeList[index].question_sort = this.codeList[index2].question_sort;
          this.codeList[index2].question_sort = temp;
          this.viewer();
        } else {
          this.codeList[index].question_sort--;
          this.prev();
        }
      }
    }
  }

  next() {
    if (!!this.viewList && this.select_item) {
      //選択中のindexと 1つ前のindex
      let index = this.codeList.findIndex(i => i.code_kbn == this.select_item.code_kbn && i.disp_seq === this.select_item.disp_seq);
      let index2 = this.codeList.findIndex(i => i.code_kbn == this.select_item.code_kbn && i.disp_seq === this.select_item.disp_seq + 1);

      if (index2 > -1) {
        let temp = this.codeList[index].disp_seq;
        this.codeList[index].disp_seq = this.codeList[index2].disp_seq;
        this.codeList[index2].disp_seq = temp;
        this.viewer();
      }
    }
  }

  //コード区分の追加
  addKubun() {
    if (this.addkbn != undefined) {
      var kbn = 1;
      if (this.code_kbn_list) {
        kbn = this.code_kbn_list.length + 1;
      }
      var temp = {
        code_kbn: String(kbn),
        code_name: this.addkbn
      }

      this.code_kbn_list.push(temp);
      this.addkbn = undefined;
    }
  }

  //項目追加
  add() {
    if (this.formValue != undefined && this.formShow != undefined) {
      let code = this.code_kbn_list.find((code) => { return (code.code_kbn === this.code_kbn) });
      let disp_seq = 1;
      let no = 1;
      if (this.viewList.length > 0) {
        disp_seq = this.viewList[this.viewList.length - 1].disp_seq + 1;
        no = disp_seq;
      }

      var temp = {
        code: null,
        code_kbn: code.code_kbn,
        no: no,
        code_name: code.code_name,
        item_name: this.formValue,
        disp_seq: disp_seq,
        delete_flag: this.formShow,
        select: false,
      }
      this.codeList.push(temp);
      this.formValue = undefined;
      this.formShow = undefined;
      this.viewer();
    }
  }
}
